import React from 'react'
import SubmissionMenu from './SubmissionMenu'
import {getOnlineStatusCircle} from './get-online-status-svg'

class Combatant extends React.Component {

  renderSelectionArea() {
    if (this.props.isSelectingAction && this.props.isPlayerControlled) {
      return <SubmissionMenu model={this.props.model}/>
    }
    if (this.props.isSelectingAction && !this.props.isPlayerControlled) {
      return <div className="SubmissionMenu">Waiting for player input...</div>
    }
    return null;
  }

  renderConnectionStatus() {

    if (this.props.isConnected) {
      return (
        getOnlineStatusCircle(true)
      )
    }
    return (
      getOnlineStatusCircle(false)
    )
  }

  renderBotStatus() {
    return this.props.model.isBot ? <span>[BOT]</span> : null;
  }

  renderBuggedItemStatus() {

    const buggedItemCount = this.props.model.getTeamItems().filter(item => item.isBugged).length;

    if (buggedItemCount > 0) {
      return (
        <div>{buggedItemCount} bugged item(s)!</div>
      )
    }
    return null
  }

  renderDangerMeter() {
    return (
      <div>Danger Meter: {this.props.model.dangerMeter}%</div>
    )
  }


  render() {
    const model = this.props.model;

    const isPlayerClass = this.props.isPlayerControlled ? "is-player-controlled" : "";
    const avatarStyle = {
      backgroundImage: `url(${model.skin})`,
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat"
    };

    return (
      <div className={`Combatant ${isPlayerClass}`}>

        {
          this.props.isPlayerControlled ? <div style={{color:"green"}}>This is you</div> : null
        }

                                               {/* Avatar & Bio*/}
          <div className="Combatant-avatar" style={avatarStyle}>
          </div>
          <div style={{display: "inline-block"}}>
            <span className="Combatant-name">{model.name} {this.renderBotStatus()} {this.renderConnectionStatus()}</span>
            <span className="Combatant-level">LVL {model.level} {model.class}</span>
          </div>

                                               {/* Stats, etc*/}
          <div>
            <div>
              HP: {model.hp} / {model.maxHp}
            </div>
            <div>
              PP: {model.pp} / {model.maxPp}
            </div>
            <div>
              {this.renderDangerMeter()}
            </div>
            {/*<div>*/}
            {/*Team: {model.belongsToTeam}*/}
            {/*</div>*/}
            {
              model.status !== "normal"
                ? <div>{model.status}</div>
                : null
            }
            {
              Boolean(model.committedTurnData)
                ? <div>COMMIT!</div>
                : null
            }
            {this.renderBuggedItemStatus()}
            {this.renderSelectionArea()}


          </div>
      </div>
    );
  }
}

// Combatant.propTypes = {
//   /*someRequiredProp: React.PropTypes.string.isRequired*/
//   model: React.PropTypes.object.isRequired,
//   isSelectingAction: React.PropTypes.bool.isRequired,
//   isPlayerControlled: React.PropTypes.bool.isRequired,
//   isConnected: React.PropTypes.bool.isRequired,
// };


export default Combatant;


// WEBPACK FOOTER //
// ./src/battle/ConsoleView/Combatant.js